
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".25","y":".25","width":"119.5","height":"35.5","rx":"7.75","fill":"#fff","stroke":"#AEB1BA","stroke-width":".5"}}),_c('path',{attrs:{"d":"M36 18h49.23","stroke":"#AEB1BA","stroke-width":"2","stroke-linecap":"round","stroke-dasharray":"2 5"}})])
          )
        }
      }
    